import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class WithdrawAccountAuditApi extends BasicsClass {
    public apiUrls: any = new Map([
        ['getList', {
            url: '/admin/withdraw/banks',
            name: 'list',
            label: '列表'
        }],
        ['exportExcelList', {
            url: '/admin/withdraw/exportBanks',
            name: 'export-excel',
            label: '导出'
        }],
        ['updateWithdrawAccountAuditPassStatus',  {
            url: '/admin/withdraw/bankApproved',
            name: 'pass-status',
            label: '审核通过'
        }],
        ['updateWithdrawAccountAuditRejectStatus',  {
            url: '/admin/withdraw/bankReject',
            name: 'reject-status',
            label: '审核拒绝'
        }]
    ])
    
    // momo达到家-提现审核列表
    public getList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

     // momo达到家-提现审核列表
    public exportExcelList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('exportExcelList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // 提现审核状态更新
    public updateWithdrawAccountAuditStatus(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls
        
        const urlModes: any = {
            'agree': apiUrls.get('updateWithdrawAccountAuditPassStatus').url,
            'disagree': apiUrls.get('updateWithdrawAccountAuditRejectStatus').url,
        }

        let url: string = urlModes[params.mode]

        delete params.mode

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading);
    }
}